exports.unixTime = function () {
  const date = new Date();
  return Math.floor(date.getTime() / 1000);
};

// Format date function
exports.dateFormat = date => {
  const newDate = new Date(parseInt(date) * 1000);
  return `${`0${newDate.getDate()}`.slice(-2)}/${`0${parseInt(newDate.getMonth()) + 1}`.slice(-2)}/${newDate.getFullYear()}`;
};

// Format datetime function
exports.timeFormat = date => {
  const newDate = new Date(parseInt(date) * 1000);
  return `${`0${newDate.getHours()}`.slice(-2)}:${`0${newDate.getMinutes()}`.slice(-2)}`;
};

// Format datetime function
exports.datetimeFormat = date => {
  return `${exports.timeFormat(date)} ${exports.dateFormat(date)}`;
};

exports.capitalizeLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

exports.commaFormat = x => {
  const parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

exports.timeSince = date => {
  if (date === 0) {
    return 'Never';
  }

  const seconds = Math.floor(new Date().getTime() / 1000 - date);
  let interval = Math.floor(seconds / 31536000);

  if (interval >= 1) {
    return `${interval} year${interval === 1 ? ' ago' : 's ago'}`;
  }
  interval = Math.floor(seconds / 2592000);
  if (interval >= 1) {
    return `${interval} month${interval === 1 ? ' ago' : 's ago'}`;
  }
  interval = Math.floor(seconds / 86400);
  if (interval >= 1) {
    return `${interval} day${interval === 1 ? ' ago' : 's ago'}`;
  }
  interval = Math.floor(seconds / 3600);
  if (interval >= 1) {
    return `${interval} hour${interval === 1 ? ' ago' : 's ago'}`;
  }
  interval = Math.floor(seconds / 60);
  if (interval >= 1) {
    return `${interval} minute${interval === 1 ? ' ago' : 's ago'}`;
  }
  interval = Math.floor(seconds);
  if (interval >= 1) {
    return `${interval} second${interval === 1 ? ' ago' : 's ago'}`;
  }

  return 'just now';
};
